import { datadogRum } from '@datadog/browser-rum';
import dynamic from 'next/dynamic';
import { FEATURE_FLAGS } from '~/constants';
import { useUserSettings } from '~/hooks/useUserSettings.ts';

import { useFlagStore } from './store';

const FeatureFlagController = dynamic(
  () => import('./FeatureFlagsController'),
  { ssr: false },
);

export const FeatureFlags = () => {
  const { status, setStatus, updateFlags } = useFlagStore();

  const featureFlags = useUserSettings({
    onSuccess: (data) => {
      updateFlags(data.enabled_features);
      setStatus('success');

      // Send feature flag evaluations to Datadog
      Object.values(FEATURE_FLAGS).forEach((flag) =>
        datadogRum.addFeatureFlagEvaluation(
          flag,
          data.enabled_features.includes(flag),
        ),
      );
    },
    onRetryDelay: (retryAttempt) => {
      if (retryAttempt > 2 && status === 'loading') setStatus('error');
      return 3000; // Retry every 3 seconds
    },
    onError: () => {
      setStatus('error');
    },
  });

  const isFlagsUIEnabled = featureFlags.data?.enabled_features.includes(
    FEATURE_FLAGS.foamFeatureFlagController,
  );

  if (
    (isFlagsUIEnabled || process.env.NEXT_PUBLIC_APP_ENV === 'development') &&
    featureFlags.isSuccess &&
    featureFlags.data
  ) {
    return (
      <FeatureFlagController
        featureFlags={featureFlags.data.enabled_features}
      />
    );
  }

  return null;
};
